import React, { useEffect, useRef, useState } from "react";
import { NodeViewWrapper } from "@tiptap/react";
import { BvIcon } from "bevi-icon";
import "./html-preview-node-view.scss";

type Props = {
  node: any;
  updateAttributes: (attrs: any) => void;
};

export const HtmlPreviewNodeView: React.FC<Props> = ({
  node,
  updateAttributes,
}) => {
  const [isEditing, setIsEditing] = useState(false);
  const [value, setValue] = useState(node.attrs.code);
  const [blobUrl, setBlobUrl] = useState<string>("");
  const iframeRef = useRef<HTMLIFrameElement>(null);

  useEffect(() => {
    if (isEditing) return;
    const url = URL.createObjectURL(
      new Blob([node.attrs.code], { type: "text/html" })
    );
    setBlobUrl(url);
    return () => URL.revokeObjectURL(url);
  }, [node.attrs.code, isEditing]);

  const save = () => {
    updateAttributes({ code: value });
    setIsEditing(false);
  };

  const handleIframeLoad = () => {
    const iframe = iframeRef.current;
    if (!iframe) return;
    try {
      const body = iframe.contentWindow?.document?.body;
      const html = iframe.contentWindow?.document?.documentElement;
      const height = Math.max(
        body?.scrollHeight ?? 0,
        html?.scrollHeight ?? 0,
        240
      );
      iframe.style.height = `${height}px`;
    } catch {
      // cross-origin ou documento vazio: mantém altura padrão
    }
  };

  return (
    <NodeViewWrapper className="html-preview-node-view">
      <div className="html-preview-toolbar">
        <a
          className="icon-html"
          type="button"
          onClick={() => (isEditing ? save() : setIsEditing(true))}
        >
          {isEditing ? (
            <BvIcon
              name="check"
              variant="solid"
              weight={600}
              width={18}
              height={18}
              style={{ color: "#55565c" }}
            />
          ) : (
            <i className="fa-solid fa-code" style={{ fontSize: "13px" }}></i>
          )}
        </a>
      </div>

      {isEditing ? (
        <textarea
          value={value}
          onChange={(e) => setValue(e.target.value)}
          className="html-preview-textarea"
          spellCheck={false}
        />
      ) : (
        <iframe
          ref={iframeRef}
          title="html-preview"
          className="html-preview-render"
          sandbox="allow-scripts allow-same-origin allow-forms allow-popups allow-popups-to-escape-sandbox allow-modals"
          src={blobUrl}
          onLoad={handleIframeLoad}
        />
      )}
    </NodeViewWrapper>
  );
};
